import envConfig from './env-config.json';
export const env = envConfig;
//# sourceMappingURL=environment.js.map